import React, { useState } from "react";
import { Alert, Button, Spinner } from "react-bootstrap";
import { AiFillPrinter } from "react-icons/ai";
import api from "../Utils/api";

async function mensagemErro(error) {
  const data = error.response?.data;
  if (data instanceof Blob) {
    try {
      return JSON.parse(await data.text()).message;
    } catch {
      return "";
    }
  }
  return data?.message;
}

export default function ImprimirBoletimButton({
  report,
  prepareReport,
  className = "",
  buttonLabel = "Finalizar boletim e imprimir",
}) {
  const [isLoading, setIsLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [isError, setIsError] = useState(false);

  const imprimir = async () => {
    if (isLoading) return;

    const printWindow = window.open("", "_blank");
    if (printWindow) {
      printWindow.document.title = "Preparando boletim";
      printWindow.document.body.textContent = "Preparando a cópia para impressão...";
    }

    setIsLoading(true);
    setMessage("");
    setIsError(false);
    try {
      const persistedReport = prepareReport ? await prepareReport() : report;
      if (persistedReport?._offlinePending) {
        if (printWindow && !printWindow.closed) printWindow.close();
        setIsError(false);
        setMessage("Cópia provisória: este boletim ainda não foi confirmado pelo servidor. Ele será sincronizado quando a conexão retornar.");
        window.setTimeout(() => window.print(), 100);
        return;
      }
      if (!persistedReport?._id) {
        throw new Error("Não foi possível confirmar o boletim no servidor para emitir a cópia oficial.");
      }

      const response = await api.post(
        `/incidentReport/${encodeURIComponent(persistedReport._id)}/documents`,
        {},
        { responseType: "blob" }
      );
      const url = window.URL.createObjectURL(response.data);

      if (printWindow && !printWindow.closed) {
        printWindow.addEventListener(
          "unload",
          () => window.URL.revokeObjectURL(url),
          { once: true }
        );
        printWindow.location.href = url;
        printWindow.focus();
      } else {
        const anchor = document.createElement("a");
        anchor.href = url;
        anchor.download = `BO_${String(persistedReport.numero || "boletim").replace(/[^a-zA-Z0-9_-]/g, "_")}.pdf`;
        document.body.appendChild(anchor);
        anchor.click();
        anchor.remove();
        window.setTimeout(() => window.URL.revokeObjectURL(url), 1000);
        setIsError(false);
        setMessage("A janela de impressão foi bloqueada; a cópia foi baixada para impressão.");
      }
    } catch (error) {
      if (printWindow && !printWindow.closed) printWindow.close();
      setIsError(true);
      setMessage(
        (await mensagemErro(error)) ||
          error.message ||
          "Não foi possível preparar a cópia para impressão."
      );
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className={className}>
      <Button
        type="button"
        variant="warning"
        size="sm"
        disabled={(!report?._id && !prepareReport) || isLoading}
        onClick={imprimir}
      >
        {isLoading ? (
          <>
            <Spinner size="sm" animation="border" className="me-2" />
            Finalizando e preparando impressão...
          </>
        ) : (
          <>
            {buttonLabel} <AiFillPrinter />
          </>
        )}
      </Button>
      {message && (
        <Alert         variant={isError ? "danger" : "success"} className="mt-2 mb-0" role="alert">
          {message}
        </Alert>
      )}
    </div>
  );
}
